import React, { useEffect } from "react";
import { Actions as reportActions } from "../../core/redux/ducks/report";
import { Actions as articleActions } from "../../core/redux/ducks/article";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Typography } from "@material-ui/core";
import { ArticleCard } from "./ArticleCard";
import { useDispatch, useSelector } from "react-redux";
import { ReportCard } from "./ReportCard";
import useLanguage from "../../hooks/useLanguage";

export const Dashboard = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { articles } = useSelector((state) => state.article);
  const { reports } = useSelector((state) => state.report);
  const { language } = useLanguage();
  const { translate } = language;
  const fetchArticles = () => articleActions.fetchArticles(dispatch);
  const fetchReports = () =>
    reportActions.fetchReports(dispatch, { pagesize: 12, keywords: "" });

  useEffect(() => {
    fetchArticles();
    fetchReports();
  }, []);

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <Grid container>
          <Grid item className={classes.header}>
            <Typography variant="h5" gutterBottom>
              {translate.drafts_title}
            </Typography>
          </Grid>
        </Grid>
        {articles &&
          articles.map((article, index) => (
            <ArticleCard index={index} article={article} key={article.id} />
          ))}
        <Grid container className={classes.feedContainer}>
          <Grid item className={classes.header}>
            <Typography variant="h5" gutterBottom>
              Neuste Stories
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.reportsContainer}>
          {reports &&
            !!reports.reports.length &&
            reports.reports.map((report, index) => (
              <ReportCard report={report} key={index} />
            ))}
        </div>
      </Container>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    overflow: "auto",
    height: "100%",
  },
  container: {
    marginTop: "100px",
    height: "100%",
  },
  body: {
    flex: 1,
  },
  header: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    width: "100%",
  },
  feedContainer: {
    marginTop: "100px",
  },
  reportsContainer: {
    columns: "3 auto",
    margin: "10px 0",
  },
}));
